import { ListItemSchemaOrg } from './ListItem';
import { Schema } from 'effect';

/**
 * @see https://schema.org/BreadcrumbList
 */
export const BreadcrumbListSchemaOrg = Schema.Struct({
  '@context': Schema.Literal('https://schema.org'),
  '@type': Schema.Literal('BreadcrumbList'),
  itemListElement: Schema.Array(ListItemSchemaOrg),
});
